import { useEffect, useState } from 'react';

const navItems = [
  { href: '#hot', label: '今日瓜榜' },
  { href: '#star', label: '明星八卦' },
  { href: '#social', label: '社会热点' },
  { href: '#feature', label: '编辑精选' },
  { href: '#faq', label: '吃瓜答疑' },
  { href: '#about', label: '关于我们' },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 max-w-[1320px] items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a
          href="#top"
          className="group flex items-center gap-2.5"
          aria-label="吃瓜视界 返回首页"
          onClick={() => setOpen(false)}
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'bg-primary-500' : 'bg-primary-500'
            }`}
          >
            <i className="ri-flashlight-fill text-lg text-background-50" style={{ width: 20, height: 20 }} />
          </span>
          <span
            className={`font-heading text-xl font-black tracking-tight transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            吃瓜视界
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors hover:bg-primary-500/10 hover:text-primary-600 ${
                  scrolled ? 'text-foreground-700' : 'text-background-50/90 hover:bg-background-50/10 hover:text-background-50'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:inline-flex"
          >
            线索投稿
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? '关闭菜单' : '打开菜单'}
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors lg:hidden ${
              scrolled ? 'text-foreground-950 hover:bg-background-200' : 'text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'} style={{ width: 22, height: 22, fontSize: 22 }} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur-md lg:hidden">
          <ul className="grid grid-cols-2 gap-1 sm:grid-cols-3">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-500/10 hover:text-primary-600"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-2 flex w-full items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
          >
            线索投稿
          </a>
        </div>
      )}
    </header>
  );
}